import {useMediaQuery} from 'usehooks-ts';

export const isMobile = () => useMediaQuery('(max-width: 996px)');
